import clsx from 'clsx';

import { Icon } from '@/components/icon';
import { Text } from '@/components/text';

import PlanListItem from './plan-list-item';

import type { PlanListGroupProps } from './plan-list.types';

const PlanListGroup = ({
  icon,
  title,
  items,
  showTariff = true,
}: PlanListGroupProps) => (
  <div>
    <div className="flex flex-row items-center max-md:mb-d max-md:pt-e md:py-b">
      {icon ? (
        <Icon
          icon={icon}
          className="mr-b h-icon-xs w-icon-xs text-pink"
        />
      ) : null}
      <Text
        variant="h3"
        as="h3"
      >
        {title}
      </Text>
    </div>

    <div className="hidden grid-cols-4 p-b md:grid">
      <div className={clsx([showTariff ? 'col-span-1' : 'col-span-2'])}>
        Energy plan
      </div>
      {showTariff ? <div className="col-span-1">Tariff type</div> : null}
      <div className="col-span-1">Provider</div>
      <div className="col-span-1">Plan ID</div>
    </div>
    <div
      className="flex flex-col gap-y-b"
      role="list"
    >
      {items.map((item) => (
        <PlanListItem
          key={`${item.planName
            .toLowerCase()
            .replace(' ', '-')}-${item.planID.toLowerCase()}${
            item.climateZone ? `-${item.climateZone}` : ''
          }`}
          {...item}
        />
      ))}
    </div>
  </div>
);

export default PlanListGroup;
